module.exports = __webpack_public_path__ + "img/charactors3.4e1232de.png";